export const NAME_REDUCER = 'auth';

export const PREFIX_ACTIONS = 'auth_feature_';


export const PATH_LOADING = {
  ownerLogin: `loading.${NAME_REDUCER}.ownerLogin`,
};
